import type { GridMapboxStyle } from './styles';

export const gridsTownship = (style: GridMapboxStyle) => [
  {
    minzoom: 9,
    layout: {
      'text-field': ['get', 'label'],
      'text-size': style.textSize,
      'text-allow-overlap': false,
      'text-ignore-placement': false,
      visibility: 'visible',
    },
    type: 'symbol',
    id: 'township-labels',
    paint: {
      'text-color': style.textColor,
      ...(style.textHaloColor &&
        style.textHaloWidth && {
          'text-halo-color': style.textHaloColor,
          'text-halo-width': style.textHaloWidth,
        }),
    },
    source: 'grids',
    'source-layer': 'twp_centers',
  },
  {
    minzoom: 9,
    type: 'line',
    id: 'township-grid',
    paint: {
      'line-color': style.lineColor,
      'line-width': style.lineWidth,
    },
    source: 'grids',
    'source-layer': 'twp',
    layout: {
      visibility: 'visible',
    },
  },
];
